// v19-R1 R2: overlegdag-regels. Vertrekt altijd van de regels van de server, zodat de volgorde van klikken niet uitmaakt.
export const dagVan = (regels, w) => {
  const r = [...(regels || [])].sort((x, y) => x.vanafWeek.localeCompare(y.vanafWeek));
  const g = r.filter((x) => x.vanafWeek <= w);
  return (g.length ? g[g.length - 1] : r[0] || { dag: 0 }).dag;
};

export const pasDagToe = (serverRegels, dag, w) => [...(serverRegels || []).filter((x) => x.vanafWeek < w), { vanafWeek: w, dag }];

// v19-R1 R4: eerdere week = de opgeslagen antwoorden met hun eigen tekst; deze week = config + verwijderde vragen met antwoord (alleen lezen).
export function vragenVoor(d) {
  const cfg = d.vragenCfg || [];
  const volgorde = (id) => { const i = cfg.findIndex((v) => v.id === id); return i < 0 ? 999 : i; };
  const opgeslagen = Object.entries(d.vragen || {}).map(([id, v]) => ({ id, tekst: v.tekst, antwoord: v.antwoord, lezen: true }));
  if (!d.bewerkbaar) return opgeslagen.sort((a, b) => volgorde(a.id) - volgorde(b.id));
  const weg = opgeslagen.filter((v) => !cfg.some((c) => c.id === v.id) && v.antwoord);
  return [...cfg.map((c) => ({ id: c.id, tekst: d.vragen?.[c.id]?.tekst || c.text, antwoord: d.vragen?.[c.id]?.antwoord || "", lezen: false })), ...weg];
}
